import {Splide} from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const sliderTop = document.getElementById("sliderTop");
if (sliderTop) {
    new Splide(sliderTop, {
        type   : 'loop',
        arrows: true,
        perPage: 4,
        pagination: false,
        autoplay: false,
        interval: 2500,
        speed: 2000,
        gap    : '1rem',
        breakpoints: {
            1200: {
                perPage: 3,
            },
            1023: {
                perPage: 2,
            },
            767: {
                perPage: 1,
            },
        },
    }).mount();
}

const sliderLatest = document.getElementById("sliderLatest");
if (sliderLatest) {
    new Splide(sliderLatest, {
        type   : 'loop',
        arrows: true,
        perPage: 4,
        pagination: false,
        autoplay: false,
        interval: 2500,
        speed: 2000,
        gap    : '1rem',
        breakpoints: {
            1200: {
                perPage: 3,
            },
            1023: {
                perPage: 2,
            },
            767: {
                perPage: 1,
            },
        },
    }).mount();
}

const sliderGallery = document.getElementById("gallerySlider");
if (sliderGallery) {
    new Splide(sliderGallery, {
        type   : 'loop',
        arrows: false,
        perPage: 4,
        pagination: false,     
        autoplay: true,
        interval: 2500, 
        speed: 2000,
        focus    : 'center',
        autoWidth: true, 
        gap    : '1rem', 
        breakpoints: {
            1024: {
                perPage: 2,  // Display 2 slides on tablets
            },
            767: {
                perPage: 1,  // Display 1 slide on mobile
            },
        },
    }).mount();
}
